import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { landingApi } from './features/landing/landingFetch';
import { destinationApi } from './features/destination/destinationFetch';
import { traveldatesApi } from './features/traveldates/traveldatesFetch';
import { devicesAndPlansApi } from './features/devicesAndPlans/devicesAndPlansFetch';
import { reptoolApi } from './features/reptool/reptoolFetch';
import { confirmationApi } from './features/confirmation/confirmationFetch';
import { landingPageApi } from './features/destination/landingPageFetch';
import { effectiveDateApi } from './features/effectiveDate/effectiveDateFetch';
import { billSummaryApi } from './features/devicesAndPlans/billSummaryFetch';
import rootReducer from './features/selectedData/selectedDataReducer';
import persistantReducer from './features/selectedData/persistantDataReducer';
import { cancelPendingOrderApi } from './features/devicesAndPlans/cancelPendingOrderFetch';
import {getDevicesUaApi} from './features/devicesAndPlans/plansFetch';

const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, persistantReducer);

export const store = configureStore({
  reducer: {
    [landingApi.reducerPath] : landingApi.reducer,
    [destinationApi.reducerPath] : destinationApi.reducer,
    [landingPageApi.reducerPath]: landingPageApi.reducer,
    [traveldatesApi.reducerPath] : traveldatesApi.reducer,
    [devicesAndPlansApi.reducerPath] : devicesAndPlansApi.reducer,
    [reptoolApi.reducerPath] : reptoolApi.reducer,
    [confirmationApi.reducerPath] : confirmationApi.reducer,
    [effectiveDateApi.reducerPath] : effectiveDateApi.reducer,
    [billSummaryApi.reducerPath] : billSummaryApi.reducer,
    persistantReducer: persistedReducer, 
    [cancelPendingOrderApi.reducerPath] : cancelPendingOrderApi.reducer, 
    [getDevicesUaApi.reducerPath] : getDevicesUaApi.reducer,
    selectedReducer: rootReducer
  },

  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(landingApi.middleware, destinationApi.middleware, landingPageApi.middleware,
      traveldatesApi.middleware,devicesAndPlansApi.middleware,confirmationApi.middleware, effectiveDateApi.middleware, billSummaryApi.middleware,cancelPendingOrderApi.middleware,
      getDevicesUaApi.middleware, reptoolApi.middleware) 
})

export const persistor = persistStore(store);